/** @type {import('../schema').ProcessDefinition} */
const obras = {
  id: "obras",
  name: "Obras y proyectos",
  category: "operaciones",
  outcome:
    "Gobernar obras/mejoras con su legajo documental por organismo (BPS, DGI, Intendencia, seguros).",
  trigger: "El Administrador crea un proyecto.",
  actors: ["Administrador", "Sistema", "Proveedor"],
  status: "COMPLETO",
  description:
    "Gestión de obras y proyectos del edificio: creación con contratista y presupuesto, legajo documental requerido por organismo (checklist), carga de documentación, seguimiento del estado y cierre con acta/certificado.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "prov", actor: "Proveedor" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Crea el proyecto", description: "Nombre, contratista, presupuesto y fechas.", evidence: "src/screens/admin/ProyectosAdmin.jsx" },
    { id: "s2", laneId: "sys", type: "document", label: "Genera el legajo", description: "Matriz de documentos requeridos por organismo (BPS, DGI, Intendencia, seguros) como checklist." },
    { id: "s3", laneId: "prov", type: "handoff", label: "Contratista entrega la documentación", description: "El admin pide los documentos al contratista; si no entrega, se le recuerda." },
    { id: "s4", laneId: "admin", type: "task", label: "Carga la documentación", description: "Sube documentos por categoría; avanza el checklist (pendiente → adjuntado).", evidence: "src/screens/ObrasYProyectos.jsx" },
    { id: "s5", laneId: "admin", type: "task", label: "Seguimiento del proyecto", description: "Actualiza el estado: planificado → en curso → pausado. Presupuesto excedido → nota." },
    { id: "s6", laneId: "admin", type: "decision", label: "¿Todo recolectado?" },
    { id: "s7", laneId: "admin", type: "end", label: "Cierra con acta/certificado", description: "Finaliza el proyecto con acta o certificado (estado: finalizado)." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7", label: "sí" },
    { from: "s6", to: "s3", label: "faltan docs" },
  ],
};

export default obras;
